import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types - Construction Projects
export const GET_CONSTRUCTION_PROJECTS = 'GET_CONSTRUCTION_PROJECTS';
export const GET_CONSTRUCTION_PROJECT = 'GET_CONSTRUCTION_PROJECT';
export const CREATE_CONSTRUCTION_PROJECT = 'CREATE_CONSTRUCTION_PROJECT';
export const UPDATE_CONSTRUCTION_PROJECT = 'UPDATE_CONSTRUCTION_PROJECT';
export const DELETE_CONSTRUCTION_PROJECT = 'DELETE_CONSTRUCTION_PROJECT';
export const UPDATE_PROJECT_PROGRESS = 'UPDATE_PROJECT_PROGRESS';
export const GET_PROJECT_DASHBOARD = 'GET_PROJECT_DASHBOARD';

// Get all construction projects
export const getConstructionProjects = (searchQuery, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchConstructionProjects(searchQuery, page, pageSize);
    
    dispatch({ 
      type: GET_CONSTRUCTION_PROJECTS, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching construction projects:', error);
    throw error;
  }
};

// Get single construction project
export const getConstructionProject = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchConstructionProject(id);
    
    dispatch({ 
      type: GET_CONSTRUCTION_PROJECT, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching construction project:', error);
    throw error;
  }
};

// Create construction project
export const createConstructionProject = (projectData, openSnackbar, history, currentLang) => async (dispatch) => {
  try {
    const { data } = await api.createConstructionProject(projectData);
    
    dispatch({ 
      type: CREATE_CONSTRUCTION_PROJECT, 
      payload: data 
    });
    
    openSnackbar('Construction project created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Construction project created successfully"));
    history.push(`/${currentLang}/app/construction/projects/${data._id}`);
    
    return data;
  } catch (error) {
    console.error('Error creating construction project:', error);
    openSnackbar('Error creating construction project', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating construction project"));
    throw error;
  }
};

// Update construction project
export const updateConstructionProject = (id, projectData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateConstructionProject(id, projectData);
    
    dispatch({ 
      type: UPDATE_CONSTRUCTION_PROJECT, 
      payload: data 
    });
    
    openSnackbar('Construction project updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Construction project updated successfully"));
    
    return data;
  } catch (error) {
    console.error('Error updating construction project:', error);
    openSnackbar('Error updating construction project', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating construction project"));
    throw error;
  }
};

// Delete construction project
export const deleteConstructionProject = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteConstructionProject(id);
    
    dispatch({ 
      type: DELETE_CONSTRUCTION_PROJECT, 
      payload: id 
    });
    
    openSnackbar('Construction project deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Construction project deleted successfully"));
  } catch (error) {
    console.error('Error deleting construction project:', error);
    openSnackbar('Error deleting construction project', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting construction project"));
    throw error;
  }
};

// Update project progress
export const updateProjectProgress = (id, progressData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateProjectProgress(id, progressData);
    
    dispatch({ 
      type: UPDATE_PROJECT_PROGRESS, 
      payload: data 
    });
    
    openSnackbar('Project progress updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Project progress updated successfully"));
    
    return data;
  } catch (error) {
    console.error('Error updating project progress:', error);
    openSnackbar('Error updating project progress', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating project progress"));
    throw error;
  }
};

// Get project dashboard
export const getProjectDashboard = (id) => async (dispatch) => {
  try {
    const { data } = await api.getProjectDashboard(id);
    
    dispatch({ 
      type: GET_PROJECT_DASHBOARD, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching project dashboard:', error);
    throw error;
  }
};

// Add milestone
export const addMilestone = (projectId, milestoneData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addMilestone(projectId, milestoneData);
    
    dispatch({ 
      type: UPDATE_CONSTRUCTION_PROJECT, 
      payload: data 
    });
    
    openSnackbar('Milestone added successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Milestone added successfully"));
    
    return data;
  } catch (error) {
    console.error('Error adding milestone:', error);
    openSnackbar('Error adding milestone', SNACKBAR_DURATION_MS, getSnackbarColor("Error adding milestone"));
    throw error;
  }
};

// Add variation order
export const addVariation = (projectId, variationData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addVariation(projectId, variationData);
    
    dispatch({ 
      type: UPDATE_CONSTRUCTION_PROJECT, 
      payload: data 
    });
    
    openSnackbar('Variation order added successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Variation order added successfully"));
    
    return data;
  } catch (error) {
    console.error('Error adding variation:', error);
    openSnackbar('Error adding variation', SNACKBAR_DURATION_MS, getSnackbarColor("Error adding variation"));
    throw error;
  }
};

// Approve variation order
export const approveVariation = (projectId, variationId, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.approveVariation(projectId, variationId);
    
    dispatch({ 
      type: UPDATE_CONSTRUCTION_PROJECT, 
      payload: data 
    });
    
    openSnackbar('Variation order approved successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Variation order approved successfully"));
    
    return data;
  } catch (error) {
    console.error('Error approving variation:', error);
    openSnackbar('Error approving variation', SNACKBAR_DURATION_MS, getSnackbarColor("Error approving variation"));
    throw error;
  }
};
